import { useRichTextEditorContext } from "@mantine/tiptap";

/**
 * Derives the disabled state for a RichTextEditor control. If `explicit` is set (true or false), it takes
 * precedence — callers can always override. Otherwise the value falls through to `!editor.isEditable` so that calling
 * `editor.setEditable(false)` on the surrounding `useEditor` is enough to grey out every control automatically.
 *
 * Tiptap's React integration re-renders the consumer on every transaction (including the one fired by
 * `setEditable`), so the read here stays reactive without an explicit subscription.
 *
 * @param {boolean | undefined} explicit Optional caller-supplied override.
 * @returns {boolean} The effective disabled state.
 */
export const useEditorDisabled = (explicit?: boolean): boolean => {
    const { editor } = useRichTextEditorContext();
    return explicit ?? !editor?.isEditable;
};
